import p5 = require("p5");
import { sketch } from "./sketch"

new p5(sketch)